import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { HisNotificationService } from 'hisng';

import { ResearchPartnerWrapperUtils } from 'app/fs/res/common/utils/researchPartner-wrapper-utils';
import { Person } from 'app/fs/res/common/model/person/person';
import { ResearchPartner, ResearchPartnerSimple } from 'app/fs/res/common/model/researchPartner/researchPartner';

import { PatentService } from 'app/fs/res/patent/service/patent/patent.service';
import { PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';

@Component( {
    selector: 'res-patent-external-inventor-dialog',
    templateUrl: './patent-external-inventor-dialog.component.html',
} )
export class PatentExternalInventorDialogComponent implements OnInit {
    @Input() patentInventor: PatentInventor;
    @Input() visibility = false;
    @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter();
    @Output() savePatentInventorChange: EventEmitter<PatentInventor> = new EventEmitter();

    public currentPatentInventor: PatentInventor = new PatentInventor();
    public person: Person = new Person();
    public researchPartner: ResearchPartner;
    public externalOrganizations: ResearchPartnerSimple[] = [];
    public isAddOrganization = true;

    externalOrganizationModel: any;

    constructor( private notificationService: HisNotificationService,
        private patentService: PatentService ) {
    }

    ngOnInit() {
        if( this.patentInventor == null ) {
            this.currentPatentInventor.person = new Person();
        } else {
            // assign a copy of the original object without reference
            Object.assign( this.currentPatentInventor, this.patentInventor );
            this.externalOrganizations.push(this.patentInventor.researchPartner as ResearchPartnerSimple);
            this.isAddOrganization = false;
        }
    }

    public savePatentInventor() {
        // needed for validation of empty inputfields
        for ( let [k,v] of Object.entries(this.currentPatentInventor.person ) ) {
            if(!v){ (this.currentPatentInventor.person as any)[k] = null;}
        }

        if ( this.researchPartner?.id ) {
            this.currentPatentInventor.researchPartner =
                ResearchPartnerWrapperUtils.transformToResearchPartnerSimple( this.researchPartner );
        }
        if ( !this.currentPatentInventor.id ) {
            this.patentService.saveExternalPersonInventor( this.currentPatentInventor ).subscribe(
                ( patentInventor: PatentInventor ) => {
                    this.currentPatentInventor = patentInventor;
                    this.saveAndEmitChanges();
                } );
        } else {
            this.saveAndEmitChanges();
        }
    }

    /* close dialog action */
    public closeDialog() {
        this.visibilityChange.emit(false);
    }

    private saveAndEmitChanges() {
        this.notificationService.infoI18n( 'de.his.javang.gefunden.change' );
        if( this.patentInventor == null ) {
            this.savePatentInventorChange.emit( this.currentPatentInventor );
        } else {
            // write changes back to original object on apply
            Object.assign( this.patentInventor, this.currentPatentInventor );
        }
        this.closeDialog();
    }

    /* ----------- external organisation actions ------------- */

    public organizationsChange( event: ResearchPartnerSimple[] ) {
        this.researchPartner = ResearchPartnerWrapperUtils.transformToResearchPartnerComplex( event[0] as ResearchPartnerSimple );
        this.isAddOrganization = false;
    }

    /* call back method to delete given research partner form array */
    public deleteExternalOrganizationChange() {
        this.externalOrganizations = [];
        this.isAddOrganization = true;
        this.researchPartner = new ResearchPartner();
        this.currentPatentInventor.researchPartner = null;
    }
}
